import React from 'react';
import { css } from "@emotion/react";

import logo from '../../images/WTB_logo.png'
import Profile from "./Profile";
import { CORPORATE_URL } from "../../config/config";

const Header = () => (
    <div css={wrapperStyle}>
        <div css={containerStyle}>
            <a href={CORPORATE_URL}>
                <img src={logo} alt={"Writer's Toolbox Logo"} css={imageStyle} />
            </a>
        </div>
        <Profile />
    </div>
);

export default Header;

const wrapperStyle = css`
    width: 100%;
    height: 87px;
    display: flex;
    box-shadow: 0 3px 15px #00000029;
    margin-bottom: 20px;
`;

const containerStyle = css`
    width: 100%;
    height: 87px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const imageStyle = css`
    height: 28px;
`;